import React, { Fragment } from 'react';
import Link from 'shared/SlashLink';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import PolicySection from './Policy';
import offerBanner from '../../images/icons/best_offer.svg.svg';
import PartnerSection from '../../components/PartnerSection';


const PricingPage = (props) => {

    usePageSeo({
        title: 'Pricing — Design Fees & Managed IT Plans',
        description: 'Transparent BUILDLAB pricing — $310/unit affordable housing technology design, Managed IT plans from $125/user/mo, and AI Business Integration services.',
        keywords: 'BUILDLAB pricing, technology consulting cost, per-unit pricing, affordable housing pricing, managed IT plans',
    });


    return (
        <Fragment>
            <Header />
            <main id="main-content" className="page_content about-page">
                <PageTitle pageTitle={'Pricing Plan'} pagesub={'Pricing '} pageTop={'Our'} />
                <PolicySection />
                <section className="pricing_section section_space pb-0 bg-light">
                    <div className="container">
                        <div className="heading_block text-center">
                            <div className="heading_focus_text mb-2">
                                Our
                                <span className="badge bg-secondary text-white">Pricing</span>
                            </div>
                            <h2 className="heading_text mb-3">
                                Two tracks. Transparent pricing.
                            </h2>
                            <p className="heading_description mb-0">
                                BUILDLAB scopes work to the project. Construction Tech Design is priced per unit. Business IT is priced per engagement. No hidden fees, no upcharges, no surprises.
                            </p>
                        </div>
                        <div className="row justify-content-center mt-5">
                            <div className="col-lg-6">
                                <div className="pricing_block">
                                    <div className="best_plan">
                                        <img src={offerBanner} alt="Featured" />
                                    </div>
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <span className="pricing_monthly">
                                                $310 <sub>per unit · one-time</sub>
                                            </span>
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Construction Tech Design</h3>
                                            <p className="pricing_package_description mb-0">
                                                Full-scope technology design and coordination for affordable housing and multifamily developments — from pre-construction to operations handoff.
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">ISP negotiation &amp; ROE management (door fees, profit-share)</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Low-voltage, structured cabling &amp; Div 27/28 specs</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Surveillance, door access &amp; computer networks</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">OAC coordination &amp; milestone tracking through closeout</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Grant identification &amp; CASF/CPUC application support</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Property management training &amp; documentation</span>
                                        </li>
                                    </ul>
                                    <Link onClick={() => window.scrollTo(0, 0)} to="/affordable-housing" className="btn btn-light">
                                        <span className="btn_label" data-text="See ROI Calculator">See ROI Calculator</span>
                                        <span className="btn_icon"><i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i></span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="pricing_block">
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <span className="pricing_monthly">
                                                Custom <sub>scoped to your business</sub>
                                            </span>
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Managed IT + AI</h3>
                                            <p className="pricing_package_description mb-0">
                                                Day-to-day technology operations for growing businesses — and a complimentary AI Business Integration assessment included with every new subscription.
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Systems, network &amp; endpoint administration</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Cyber security: audits, monitoring &amp; incident response</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Cloud infrastructure, backups &amp; disaster recovery</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">AI Business Integration assessment (included)</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Web development &amp; digital marketing programs</span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon"><i className="fa-regular fa-circle-check" aria-hidden="true"></i></span>
                                            <span className="icon_list_text">Vendor &amp; license management, help desk for your team</span>
                                        </li>
                                    </ul>
                                    <Link onClick={() => window.scrollTo(0, 0)} to="/managed-it-offer" className="btn btn-light">
                                        <span className="btn_label" data-text="See the Offer">See the Offer</span>
                                        <span className="btn_icon"><i className="fa-solid fa-arrow-up-right" aria-hidden="true"></i></span>
                                    </Link>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5 pt-4">
                            <div className="col-12">
                                <div className="heading_block text-center mb-4">
                                    <h3 className="heading_text mb-1" style={{ fontSize: '1.5rem' }}>Add-on services</h3>
                                    <p className="heading_description mb-0">Available on construction engagements.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mt-3">
                                <div style={{ background: '#fff', border: '1px solid var(--bs-border-color)', borderRadius: '12px', padding: '24px', height: '100%' }}>
                                    <h4 style={{ fontSize: '1rem', color: 'var(--bs-dark)', marginBottom: 6 }}>DAS / ERCCS Site Survey</h4>
                                    <div style={{ fontFamily: 'Axiforma Bold, sans-serif', color: 'var(--bs-primary)', fontSize: '1.4rem', margin: '8px 0' }}>$30 <span style={{ fontSize: '.85rem', color: 'var(--bs-body-color)', fontWeight: 400 }}>/ unit</span></div>
                                    <p style={{ fontSize: '.85rem', marginBottom: 0 }}>Initial site survey for permitting. Saves avg $4,840 vs. a separate specialty vendor.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mt-3">
                                <div style={{ background: '#fff', border: '1px solid var(--bs-border-color)', borderRadius: '12px', padding: '24px', height: '100%' }}>
                                    <h4 style={{ fontSize: '1rem', color: 'var(--bs-dark)', marginBottom: 6 }}>Area of Refuge Design</h4>
                                    <div style={{ fontFamily: 'Axiforma Bold, sans-serif', color: 'var(--bs-primary)', fontSize: '1.4rem', margin: '8px 0' }}>$1,280 <span style={{ fontSize: '.85rem', color: 'var(--bs-body-color)', fontWeight: 400 }}>flat</span></div>
                                    <p style={{ fontSize: '.85rem', marginBottom: 0 }}>Emergency communications design &amp; coordination — full life-safety compliance.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mt-3">
                                <div style={{ background: '#fff', border: '1px solid var(--bs-border-color)', borderRadius: '12px', padding: '24px', height: '100%' }}>
                                    <h4 style={{ fontSize: '1rem', color: 'var(--bs-dark)', marginBottom: 6 }}>Media Kit</h4>
                                    <div style={{ fontFamily: 'Axiforma Bold, sans-serif', color: 'var(--bs-primary)', fontSize: '1.4rem', margin: '8px 0' }}>$350 <span style={{ fontSize: '.85rem', color: 'var(--bs-body-color)', fontWeight: 400 }}>/ month</span></div>
                                    <p style={{ fontSize: '.85rem', marginBottom: 0 }}>Drone flybys, photography &amp; video — marketing-ready visual assets, year-round.</p>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mt-3">
                                <div style={{ background: '#fff', border: '1px solid var(--bs-border-color)', borderRadius: '12px', padding: '24px', height: '100%' }}>
                                    <h4 style={{ fontSize: '1rem', color: 'var(--bs-dark)', marginBottom: 6 }}>Lease-Up Operations</h4>
                                    <div style={{ fontFamily: 'Axiforma Bold, sans-serif', color: 'var(--bs-primary)', fontSize: '1.4rem', margin: '8px 0' }}>Custom <span style={{ fontSize: '.85rem', color: 'var(--bs-body-color)', fontWeight: 400 }}>scope</span></div>
                                    <p style={{ fontSize: '.85rem', marginBottom: 0 }}>Landing pages, digital applications, resident workflows &amp; temp leasing office tech setup.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="client_logo_section section_space bg-light">
                    <div className="container">
                        <div className="heading_block text-center">
                            <div className="heading_focus_text mb-0">
                                <span className="badge bg-secondary text-white">Technologies</span>
                                We Work With 
                            </div>
                        </div>
                        <PartnerSection/>
                    </div>
                </div>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PricingPage;
